export default __webpack_public_path__ + "static/media/View-documentation.c93ce8a6.md";